import api from './api';

export const artikelPublicService = {
    // Get public artikels (published)
    getArtikels: async (params = {}) => {
        try {
            const response = await api.get('/artikels/public', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data artikel'
            };
        }
    },

    // Get detail artikel by slug
    getArtikelBySlug: async (slug) => {
        try {
            const response = await api.get(`/artikels/public/${slug}`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Artikel tidak ditemukan'
            };
        }
    },

    // Get artikel by ID (jika perlu)
    getArtikelById: async (id) => {
        try {
            const response = await api.get(`/artikels/public/id/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Artikel tidak ditemukan' };
        }
    },

    // Get artikel by kategori
    getArtikelsByKategori: async (kategori, params = {}) => {
        try {
            const response = await api.get('/artikels/public', {
                params: { kategori, ...params }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    // Get featured artikels
    getFeaturedArtikels: async (limit = 5) => {
        try {
            const response = await api.get('/artikels/public', {
                params: { is_featured: true, per_page: limit }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    // Increment views
    incrementViews: async (id) => {
        try {
            await api.post(`/artikels/public/${id}/views`);
            return { success: true };
        } catch (error) {
            return { success: false };
        }
    },
};

export default artikelPublicService;